var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sf-modal-layout',{attrs:{"size":"xl","title":"test","show":_vm.show_,"closeModal":_vm.closeModal}},[_c('sf-data-table',{attrs:{"rowSize":"lg","columns":_vm.columns,"rows":_vm.rows,"index":"","height":"100%"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }